import productAPI from '@/services/API/product'
import customerAPI from '@/services/API/customer'
import purchaseOrderAPI from '@/services/API/purchase-order'
import inventoryAPI from '@/services/API/inventory'
import { Message } from 'element-ui';
import moment from 'moment-timezone'
import _ from 'lodash';

//WARNING => DUPLCATED IN PurchaseORders
const actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  emit: {
    associatedStatus: 'ISSUED'
  },
  receive: {
    associatedStatus: 'RECEIVED'
  },
  receivePartiel: {
    associatedStatus: 'PARTIAL RECEIVED'
  },
  bill: {
    associatedStatus: 'BILLS'
  },
  cancel : {
    associatedStatus: 'CANCELLED'
  },
  submit : {
    associatedStatus: 'SUBMITTED'
  }
};
/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, purchaseOrderStatuses, purchaseOrder) {
  // console.log("action : ", action);
  // console.log("purchaseOrderStatuses : ", purchaseOrderStatuses);
  // console.log("purchaseOrder :"  , purchaseOrder);
  const saveStatus = purchaseOrder.status==null?purchaseOrderStatuses.find(s => s.code === 'DRAFT') : purchaseOrder.status;
  // console.log("saveStatus : ", saveStatus);
  return action==='save' ? saveStatus : purchaseOrderStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}



const initPurchaseOrderEditor = function ({commit, dispatch, root}, inventoryId){
  
  dispatch('setPurchaseOrderProp',{accountant : JSON.parse(localStorage.user)});
  dispatch('setPurchaseOrderProp',{inventoryId})
  dispatch('controlData/fetchPurchaseOrderLineCustomFieldsDefinition',null,{root:true});
}

const fetchSearchedProducts = function({ commit , state}, query) {
  commit('SET_LOADING_PRODUCTS', true);
  return productAPI.listProductsV2({paging:'no', searchTerms:query, active:true, type:1, inventoryId: state.purchaseOrder.inventoryId})
    .then(products=>{
      commit("UPDATE_PRODUCTS", products);
      commit('SET_LOADING_PRODUCTS', false);
    })

};
const fetchVendor = function({commit, dispatch}, customerId){
  commit('SET_LOADING_VENDORS', true);
  return customerAPI.fetchSearchedCustomers({paging:'no', customerId})
    .then(vendors=>{
      commit("UPDATE_VENDORS", vendors);
      commit('SET_LOADING_VENDORS', false);
    })
}
const fetchSearchedVendors = function({ commit , state}, query) {
  commit('SET_LOADING_VENDORS', true);
  return customerAPI.fetchSearchedCustomers({paging:'no', searchTerms:query})
    .then(vendors=>{
      commit("UPDATE_VENDORS", vendors);
      commit('SET_LOADING_VENDORS', false);
    })

};

const setPurchaseOrderProp = function({commit,dispatch}, purchaseOrder){
  _.forEach(['vendor','date', 'reception_planning_date','reference','reference2','adjustment', 'notes','terms_conditions','accountant', 'inventoryId','status'],prop=>{
    if(purchaseOrder.hasOwnProperty(prop)){
      commit('SET_PURCHASE_ORDER_PROPERTY', {propName : prop, propVal:purchaseOrder[prop]});
    }
  })
}

const generatePuidForPurchaseOrderLine = function({ dispatch, state }, index) {
  const line = state.purchaseOrder.lines[index];
  if (line != null) {
    return inventoryAPI.generatePuid(state.purchaseOrder.inventoryId, line.product.id)
      .then((generatedPuidResponse) => {
        //const setLineProp = function ({ commit, dispatch }, {index, lineProp}){
        dispatch('setLineProp', {index, lineProp : { generic_puid: generatedPuidResponse.puid }});
        dispatch('setLineProp', {index, lineProp : { puid: null }});
      })
  }
  return null;
}

const addLine = function ({commit, state, rootState}, product){
  return inventoryAPI.generatePuid(state.purchaseOrder.inventoryId, product.id)
    .then((generatedPuidResponse) => {
      let newLine = _.cloneDeep(state.defaultLine);
      newLine.product = _.cloneDeep(product);
      newLine.generic_puid = generatedPuidResponse.puid;
      newLine.margin_rate = newLine.product.marginRate;
      newLine.purchase_unit_price = newLine.product.purchaseUnitPrice;
      newLine.editMarginRate = false;
      newLine.qty_ordered=newLine.product.uvc;
      newLine._order = state.purchaseOrder.lines.length;

      _.forEach(rootState.controlData.purchaseOrderLinesCustomFieldsDefinition, (customField, index)=>{
          newLine.custom_fields.push({id:index, value:null, code:customField.value.code});
      })

      const params = {
        id: product.id,
        paging: 'no'
      }
      return inventoryAPI.fetchProductsV2(params, state.purchaseOrder.inventoryId)
        .then((products) => {
          newLine.productsInventory = products;
          commit('ADD_LINE', newLine);
          return true;
        })
    });


  // return inventoryAPI.generatePuid(state.purchaseOrder.inventoryId, product.id)
  //   .then((generatedPuidResponse) => {
  //     let newLine = _.cloneDeep(state.defaultLine);
  //     newLine.product = _.cloneDeep(product);
  //     newLine.puid = generatedPuidResponse.puid;
  //     newLine.margin_rate = newLine.product.marginRate;
  //     newLine.purchase_unit_price = newLine.product.purchaseUnitPrice;
  //     newLine.editMarginRate = false;
  //     newLine.qty_ordered=newLine.product.uvc;
  //     newLine._order = state.purchaseOrder.lines.length;
  //
  //     _.forEach(rootState.controlData.purchaseOrderLinesCustomFieldsDefinition, (customField, index)=>{
  //         newLine.custom_fields.push({id:index, value:null, code:customField.value.code});
  //     })
  //     commit('ADD_LINE', newLine);
  //     return true;
  // })
}

const setProductLine = function ({commit}, {product, index}){
  commit('SET_PRODUCT_LINE', product, index);
}

const setLineProp = function ({ commit, dispatch }, {index, lineProp}){
  _.forEach(['product', 'reference','qty_ordered','qty_ordered_uvc','purchase_unit_price','purchase_description', 'puid', 'generic_puid', 'productItem'],prop=>{
    if(lineProp.hasOwnProperty(prop)){

      commit('SET_LINE_PROPERTY', {index, propName : prop, propVal:lineProp[prop]});

      if(prop=="qty_ordered" || prop=="purchase_unit_price"){
        dispatch('calculateLine', index);
      }
    }
  })
}

const calculateLine = function({ commit, state}, index){
  let margin = 0;
  let uvc = 1;
  let margin_price = 0;
  //On calcul l'UVC si l'option le permet sinon l'UVC = 1 par défaut
  if(localStorage.CALCULATE_QUANTITY_UVC!=null&&localStorage.CALCULATE_QUANTITY_UVC==='1'){
    if(state.purchaseOrder.lines[index].product.unit==1){
      uvc = state.purchaseOrder.lines[index].product.uvc;
    }
  }

  let unitPrice = (state.purchaseOrder.lines[index].purchase_unit_price + margin);
  let total = (unitPrice * uvc * state.purchaseOrder.lines[index].qty_ordered);


  //On calcul la marge si l'option le permet sinon la marge eset a 0
  if(localStorage.PURCHASE_ORDER_MARGIN!=null&&localStorage.PURCHASE_ORDER_MARGIN==='1'){
    if(state.purchaseOrder.lines[index].margin_type=='PERCENT'){
      let percent = (1 - (state.purchaseOrder.lines[index].margin_rate));
      margin_price = Math.round((state.purchaseOrder.lines[index].purchase_unit_price / percent)*100)/100;
      margin=Math.round((margin_price-state.purchaseOrder.lines[index].purchase_unit_price)*100)/100;
    }else{
      margin_price = state.purchaseOrder.lines[index].margin_rate+state.purchaseOrder.lines[index].purchase_unit_price;
      margin = state.purchaseOrder.lines[index].margin_rate;
    }

    commit('SET_LINE_PROPERTY', {index, propName : 'margin', propVal:margin});
    commit('SET_LINE_PROPERTY', {index, propName : 'margin_price', propVal:margin_price});
    total = Math.round(margin_price * state.purchaseOrder.lines[index].qty_ordered*100)/100;
  }


  commit('SET_LINE_PROPERTY', {index, propName : 'total', propVal:total});
}

const removeLine = function({ commit}, index){
  commit('REMOVE_LINE', index);
}

const reset = function({ commit }) {
  commit('RESET_STATE');
};

const postPurchaseOrder = function ({rootState, commit, state, dispatch}, action){
  let status = getStatusFromAction(action, rootState.statuses.purchaseOrderStatuses,state.purchaseOrder);
  dispatch('setPurchaseOrderProp',{status})
  const purchaseOrder = _.cloneDeep(state.purchaseOrder);
  _.forEach(purchaseOrder.lines, (line) => {

    if (_.get(line, 'productItem')  != null) {
      line.productItem = { id: _.get(line, 'productItem.id') };
    }

    if (line.puid == null) {
      line.puid = line.generic_puid;
    }
  })

  return purchaseOrderAPI.postPurchaseOrder(purchaseOrder)
    .then((purchaseOrderCreatedId)=>{
      Message.success("Votre bon de commande a été créé avec succès!");
      return purchaseOrderCreatedId;
    })
}

const putPurchaseOrder = function ({rootState, commit, state, dispatch}, action){
  let status = getStatusFromAction(action, rootState.statuses.purchaseOrderStatuses,state.purchaseOrder);
  let purchaseToUpdate = _.cloneDeep(state.purchaseOrder);

  purchaseToUpdate.status = status;
  _.forEach(purchaseToUpdate.lines, (line) => {

    if (_.get(line, 'productItem.id')  != null) {
      line.productItem = { id: _.get(line, 'productItem.id') };
    } else {
      line.fk_product_item_id = null;
    }

    if (line.puid == null) {
      line.puid = line.generic_puid;
    }
  })
  return purchaseOrderAPI.putPurchaseOrder(purchaseToUpdate)
    .then(purchaseOrderUpdated=>{
      dispatch('purchaseOrders/updateSelectedPurchaseOrder', purchaseOrderUpdated,{root:true});
    })
}

const setPurchaseOrder = function ({commit}, {purchaseOrder, products, produtItems}){
  
  commit('SET_PURCHASE_ORDER', { purchaseOrder, products });
}

const setShippingDelay = function({commit, state}, shipping_delay){
  commit('SET_SHIPPING_DELAY', shipping_delay);
  if(state.purchaseOrder.date!=null){
    let date = moment(state.purchaseOrder.date);
    date.add(shipping_delay,'days');
    commit('SET_RECEPTION_PLANNING_DATE', date.format());
  }

}

const setPurchaseOrderLineCustomField = function({commit, state},{index, customFieldIndex, customFieldValue, customFieldCode}){
  let textValue = customFieldValue;
  commit('SET_PURCHASE_ORDER_LINE_CUSTOM_FIELD', {index, customFieldIndex, customFieldValue, customFieldCode})
}

const setPurchaseOrderPriceTaxIn = function({commit},{index, price}){
  let p = price / 1.14975;
  commit('SET_PURCHASE_ORDER_LINE_PRICE_TAX_IN', {index, price});
  commit('SET_PURCHASE_ORDER_LINE_PRICE', {index, price:p});

}

const setPurchaseOrderPrice = function({commit},{index, price}){
  let p = price + (price * 0.05) + (price * 0.09975);
  commit('SET_PURCHASE_ORDER_LINE_PRICE', {index, price:p});
  commit('SET_PURCHASE_ORDER_LINE_PRICE_TAX_IN', {index, price});
}

const setMargin = function({commit, dispatch}, {rate, type, index}){
  commit('SET_MARGIN', {rate, type, index});
  dispatch('calculateLine', index);
}

const setDistinctProduct = function ({commit, state}, {distinct, index}) {
  if (distinct === true) {
    commit('SET_PUID', { puid: state.purchaseOrder.lines[index].generic_puid, index });
  }
  commit('SET_DISTINCT', {distinct, index});
}

const setOrdering_ = function({commit}, newOrdering){
  commit('SET_ORDERING', newOrdering)
}

const duplicate = function ({commit}, purchaseOrder){
  commit('DUPLICATE',purchaseOrder)
}

export default {
  setDistinctProduct,
  setOrdering_,
  fetchSearchedProducts,
  fetchSearchedVendors,
  setPurchaseOrderProp,
  addLine,
  setProductLine,
  setLineProp,
  calculateLine,
  removeLine,
  reset,
  initPurchaseOrderEditor,
  postPurchaseOrder,
  setPurchaseOrder,
  putPurchaseOrder,
  fetchVendor,
  setShippingDelay,
  setPurchaseOrderLineCustomField,
  setPurchaseOrderPriceTaxIn,
  setPurchaseOrderPrice,
  setMargin,
  duplicate,
  generatePuidForPurchaseOrderLine
};
